import * as actionTypes from './ManagedCare.action.types';
import _ from 'lodash';

const initialState = {
    patients: [],
    programTemplates: [],
    programNamesFromPatients: [],
    patientsSortBy: '',
    reverseSort: false,
    lastVisiblePatientId: null,
    positiveSearch: "",
    selectedPrograms: [],
    selectedCohortId: 0
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_PATIENT_LIST_SUCCESS: {
            const newState = _.cloneDeep(state);
            newState.patients = action.payload?.data?.map(({patient, ...other})=>({
                ...patient,
                ...other
            }));
            newState.programNamesFromPatients = [...new Set(newState.patients.flatMap(item=>item?.programs?.split(',')))];
            return newState;
        }
        case actionTypes.GET_PROGRAM_TEMPLATE_LIST_SUCCESS: {
            const newState = _.cloneDeep(state);
            newState.programTemplates = action.payload.data;
            return newState;
        }
        case actionTypes.SET_SORT_BY: {
            const newState = _.cloneDeep(state);
            newState.patientsSortBy = action.payload;
            return newState;
        }
        case actionTypes.SET_SORT_REVERSE: {
            const newState = _.cloneDeep(state);
            newState.reverseSort = action.payload;
            return newState;
        }
        case actionTypes.SET_LAST_VISIBLE_PATIENT_ID: {
            const newState = _.cloneDeep(state);
            newState.lastVisiblePatientId = action.payload;
            return newState;
        }
        case actionTypes.SET_POSITIVE_SEARCH: {
            const newState = _.cloneDeep(state);
            newState.positiveSearch = action.payload;
            return newState;
        }
        case actionTypes.SET_SELECTED_PROGRAMS: {
            const newState = _.cloneDeep(state);
            newState.selectedPrograms = action.payload;
            return newState;
        }
        case actionTypes.SET_SELECTED_COHORT_ID: {
            const newState = _.cloneDeep(state);
            newState.selectedCohortId = action.payload;
            return newState;
        }
        default:
            return state;
    }
}
